import { Component, Input, OnInit } from '@angular/core';
import { PriceList, PriceListView } from 'src/app/models/price-list.model';
import { InvoiceSaleService } from '../../pages/inventory/sales/invoice-sale/invoice-sale.service';
import { ToastrService } from 'ngx-toastr';
import { ResponseObject } from 'src/app/models/response-object.model';
import { HttpErrorResponse } from '@angular/common/http';
import { InventoryService } from 'src/app/services/inventory.service';
declare let $: any;

@Component({
  selector: 'app-price-list-modal',
  templateUrl: './price-list-modal.component.html',
  styleUrls: ['./price-list-modal.component.scss']
})
export class PriceListModalComponent implements OnInit {
  inputs = {
    productList: {
      value: null,
      verified: false,
      required: false,
      message: '',
      class: '',
      color: '',
      tooltip: 'status-warehouse',
      data: null
    }
  };
  filterProductList: any;
  productList: any;
  priceList: PriceListView[] = [];
  @Input() editCost = false;
  editing = null;

  constructor(
    private productService: InvoiceSaleService,
    private toastrService: ToastrService,
    private inventoryService: InventoryService
  ) {

  }

  ngOnInit(): void {
    $("body").on("click", function (e) {
    });
    this.productService.getProducts('').subscribe(
      {
        next: (response) => {
          this.productList = Object(response)['data'];
          this.filterProductList = this.productList;
        }
      }
    )
  }

  timeout = null;

  writeProduct(event: any, type: string) {
    this.inputs.productList.class = "typing";
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      var val = this.inputs.productList.value?.toLowerCase();
      this.filterProductList = this.productList.filter((product) => {
        return product.name.toLowerCase().includes(val) || (product.id + '').includes(val)
          || product.code.toLowerCase().includes(val) || product.barCode?.toLowerCase().includes(val);
      });
      if (this.filterProductList.length == 0) {
        this.inputs.productList.class = 'fa-xmark';
      } else {
        this.inputs.productList.class = "fa-list";
      }
    }, 300);
  }

  selectProduct(selected: any, value: string, status: number, type: string) {
    clearTimeout(this.timeout);
    var findOut: any = this.priceList.filter((pricel) => {
      return pricel.product_id == selected.id
    });
    if (findOut.length == 1) {
      this.toastrService.success("Ya se encuentra agregado a la lista");
      this.inputs.productList.value = "";
      this.inputs.productList.class = '';
      this.filterProductList = this.productList;
      $('body').click();
      return;
    }
    this.inputs.productList.class = "loading";
    this.productService.getPriceLists(selected.id).subscribe({
      next: (response: ResponseObject) => {
        console.log(response.data);
        if (response.data.length > 0) {
          var prices = response.data as PriceList;
          var newPrice = new PriceListView(prices, selected.name, selected.id);
          this.priceList.push(newPrice);
          this.toastrService.success("Agregado lista de productos");
          this.inputs.productList.value = "";
          this.inputs.productList.class = '';
          this.filterProductList = this.productList;
          $('body').click();
        }
        else {
          if (this.inputs.productList.value) {
            this.inputs.productList.class = 'fa-xmark';
          } else {
            this.inputs.productList.class = 'fa-list';
          }
          var newPrice = new PriceListView(null, selected.name, selected.id);
          this.priceList.push(newPrice);
          this.inputs.productList.value = "";
          this.inputs.productList.class = '';
          this.filterProductList = this.productList;
          this.toastrService.error("El producto que buscas no cuenta con lista de precios");
        }
      },
      error: (error: HttpErrorResponse) => {
        this.toastrService.error("Error al obtener las listas");
      }
    })
  }

  deleteProductList(product_id: number) {
    for (let i = 0; i < this.priceList.length; i++) {
      if (product_id == this.priceList[i].product_id) {
        if (this.editing && this.editing == product_id) {
          this.editing = null;
        }
        this.priceList.splice(i, 1);
        break;
      }
    }
  }

  changeCost(price) {
    if (this.editing){
      this.toastrService.info("Termina de editar el costo del producto anterior");
    } else {
      this.editing = price.product_id;
    }
  }

  saveCost(price: PriceListView) {
    if (price.loading) {
      return;
    }
    price.loading = true;
    this.inventoryService.updateProductCost(price.product_id, price.cost).subscribe({
      next: (response: ResponseObject) => {
        price.loading = false;
        this.editing = null;
        this.toastrService.info("Costo del Producto modificado correctamente!");
      },
      error: (error) => {
        price.loading = false;
        this.toastrService.error(error.error.message);
      }
    })
  }
}
